import { act_com } from '@lc/action/cardType/Common';
import { act_contract } from '@lc/action/cardType/Contract';
// import { act_player } from '@lc/action/Player';
// import { ContractMeta } from '@lc/card/meta/fw/ContractMeta';
// import { getPlayerStateWithId } from '@lc/lib/player_helper';
import { createCardContractVerbose } from '@lc/interface/card/contract/factory';
import { Contract } from '@lc/interface/card/contract/types';
import { GameState } from '@lc/interface/gameState/types';

export const getContractVerbose = (ContractMeta: Contract[]) => [
	createCardContractVerbose(
		// 117 origami
		ContractMeta[0],
		(playerData: any, gameState: GameState) =>
			act_contract.origamiCondition(playerData, gameState),
		(playerData: any, gameState: GameState) => {
			act_com.rechargeBattery(playerData, gameState);
			act_com.rechargeBattery(playerData, gameState);
		},
		(playerData: any, gameState: GameState) =>
			act_contract.origamiPenalty(playerData, gameState)
	),
	createCardContractVerbose(
		// 118 flatEarth
		ContractMeta[1],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_contract.flatEarthFunding(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.notPlayable(playerData, gameState)
	),
	createCardContractVerbose(
		// 119 termsAndConditions
		ContractMeta[2],
		(playerData: any, gameState: GameState) =>
			act_contract.termsAndConditionsCondition(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_com.gainBatteryPrecharged(playerData, gameState),
		(playerData: any, gameState: GameState) =>
			act_contract.termsAndConditionsPenalty(playerData, gameState)
	),
	createCardContractVerbose(
		// 120 comedyOfCommons
		ContractMeta[3],
		(playerData: any, gameState: GameState) =>
			act_contract.comedyOfCommonsCondition(playerData, gameState),
		(playerData: any, gameState: GameState) => {
			act_com.gainBatteryPrecharged(playerData, gameState);
			act_com.neighborsGetBatteries(playerData, gameState);
		},
		(playerData: any, gameState: GameState) =>
			act_contract.comedyOfCommonsPenalty(playerData, gameState)
	),
];
